import { PaginationInfo, RequestFilters } from '@/schema'

export enum DueStatus {
  OVERDUE = 'OVERDUE',
  DUE_TODAY = 'DUE_TODAY',
  DUE_THIS_WEEK = 'DUE_THIS_WEEK',
  NONE = 'NONE',
}

export interface MyWorkItemDTO {
  id: string
  deliverable_set_name: string
  project_id: string
  project_name: string
  due_date: string | null
  approved_at: string | null
  snapshot_comment_open: number
  last_activity_date: string
}

export interface MyWorkInProgressRequest extends RequestFilters {
  filter_by: {
    status: string[]
  }
  sort_by: string
  limit: number
  offset: number
}

export interface MyWorkCompletedRequest extends RequestFilters {
  filter_by: {
    status: string[]
  }
  sort_by: string
  limit: number
  offset: number
}

export interface MyWorkResponse {
  success: boolean
  data: MyWorkItemDTO[]
  pagination: PaginationInfo
}
